<template>
  <v-row no-gutters>
    <v-col cols="3">
      <SelectPicker
        v-model="newSession.type"
        subtitle="Type de séance *"
        :items="sessionTypes"
        icon="mdi-clock"
        :rules="mandatoryRule"
        :isdisable="editable || mandatoryTypeSession"
      />
    </v-col>
    <v-col v-for="panel in sessionConditionalFields" v-if="sessionConditionalFields" :key="`session_create_${panel.code}`" :cols="panel.cols || 4">
      <div v-if="!hiddenFields.includes(panel.code)">
        <SessionDiscipline
          v-if="panel.type=== 'custom' && panel.viewType === 'SessionDiscipline'"
        />
        <SessionProductActivity
          v-if="panel.type=== 'custom' && panel.viewType === 'SessionProductActivity'"
        />
        <TextField
          v-if="panel.viewType === 'Text'"
          v-model="newSession[panel.code]"
          :subtitle="panel.label"
          :icon="panel.icon"
          :single-line="panel.hideDefaultLabel"
          :rules="panel.mandatory ? mandatoryRule : []"
          :type="panel.type || 'string'"
        />

        <SelectPicker
          v-if="panel.viewType === 'Select'"
          v-model="newSession[panel.code]"
          :subtitle="panel.label"
          :items="panel.options || formVariables[panel.computedOptions]"
          :icon="panel.icon"
          :rules="panel.mandatory ? mandatoryRule : []"
          :multivalue="panel.multivalue || false"
        />

        <DependentSelect
          v-if="panel.viewType === 'DependentSelect'"
          v-model="newSession[panel.code]"
          :subtitle="panel.label"
          :dependent-value="newSession[panel.dependentOn]"
          :icon="panel.icon"
          :field="panel.field"
          :rules="panel.mandatory ? mandatoryRule : []"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>

import { computed, ref, inject } from '@vue/composition-api';
import TextField from '../../common/Form/TextField.vue';
import SelectPicker from '../../common/Form/SelectPicker.vue';
import DependentSelect from '../../common/Form/DependentSelect.vue';

import SessionDiscipline from './SessionDiscipline.vue';
import SessionProductActivity from './SessionProductActivity.vue';

import { isObjectEmpty, sortArray, mandatoryRule, getReferences } from '@/helpers/utils';
import { getReferencesSessionCreate } from '@/helpers/sessions';

import store from '@/store';

const sessionsField = require('../../../configs/sessionsForm.json');

const localReferences = require('../../../configs/references.json');

export default {
  components: {
    TextField,
    SelectPicker,
    DependentSelect,
    SessionDiscipline,
    SessionProductActivity
  },
  props: {
    mandatoryTypeSession: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const newSession = inject('newSession');
    const editable = inject('editable', ref(false));
    const formFields = ref(sessionsField);

    const sessionTypes = computed(() => {
      const types = getReferencesSessionCreate();

      if (!editable.value) {
        const index = types.findIndex(type => type.value === 'HORANET');

        if (index !== -1) {
          types.splice(index, 1);
        }
      }

      return types;
    });

    // filterHorseByGender
    const JumentHorses = computed(() => store.getters.horsesByGender('JUMENT'));

    const EtalonHorses = computed(() => store.getters.horsesByGender('ETALON'));

    const horseSizeCategories = computed(() => getReferences('horseSizeCategory'));
    const sessionGroups = computed(() => getReferences('equestrian_session_group_values'));

    const treatmentTypes = computed(() => {
      const types = localReferences.horse_treatment_type;
      const treatmentTypesOptions = Object.keys(types).map(type => ({ label: types[type], value: type }));
      return sortArray(treatmentTypesOptions, 'label');
    });

    const formVariables = computed(() => (
      {
        JumentHorses: JumentHorses.value,
        EtalonHorses: EtalonHorses.value,
        treatmentTypes: treatmentTypes.value,
        horseSizeCategories: horseSizeCategories.value,
        sessionGroups: sessionGroups.value || []
      }
    ));

    const sessionConditionalFields = computed(() => {
      const sessionFields = [];

      Object.keys(formFields.value).forEach(field_key => {
        const field = { ...formFields.value[field_key] };
        if (newSession.value.type && field.sessionTypes.includes(newSession.value.type)) {
          Object.keys(field.fields).map(field_code => {
            let { label } = field.fields[field_code];

            if (field.fields[field_code].mandatory) {
              label += ' *';
            }

            sessionFields.push({
              ...field.fields[field_code],
              code: field_code,
              label: label,
              field: field.fields[field_code],
              readonly: field.fields[field_code].readonly || false
            });
          });
        }
      });

      return sortArray(sessionFields, 'order');
    });

    const hiddenFields = computed(() => {
      const fieldsToHide = [];
      sessionConditionalFields.value.forEach(field => {
        if (field.hideForSessionTypes && field.hideForSessionTypes.includes(newSession.value.type)) {
          fieldsToHide.push(field.code);
        }
        if (field.hideFieldsWhen && !isObjectEmpty(field.hideFieldsWhen)) {
          if (field.hideFieldsWhen.values) {
            const filters = [];
            field.hideFieldsWhen.values.map(value => {
              filters.push(`"${newSession.value[field.code] || null}"${field.hideFieldsWhen.condition}"${value}"`);
            });
            if (eval(filters.join(' || '))) {
              field.hideFieldsWhen.fields.forEach(f => fieldsToHide.push(f));
            }
            return;
          }
          if (eval(`"${newSession.value[field.code] || null}"${field.hideFieldsWhen.condition}"${field.hideFieldsWhen.value}"`)) {
            field.hideFieldsWhen.fields.forEach(f => fieldsToHide.push(f));
          }
        }
      });
      return fieldsToHide;
    });

    return { sessionTypes, editable, sessionConditionalFields, hiddenFields, formVariables, mandatoryRule, newSession, getReferencesSessionCreate };
  }
};
</script>
